import { compose } from '@wordpress/compose';
import { withSelect } from '@wordpress/data';
import { PanelRow, ToggleControl } from '@wordpress/components';
import { store as coreStore } from '@wordpress/core-data';
import { remove } from 'lodash';

const ActivePostTypes = ( props ) => {
	const { postTypesList, updateSettings, settings } = props;
	return <>
		{ postTypesList && postTypesList.map( ( postType ) => {
			if ( ! settings.skip_gutenburg_post_type.includes( postType.slug ) ) {
				return <PanelRow key={ `post-type-${ postType.slug }` }>
					<ToggleControl
						label={ postType.labels.name }
						checked={ settings.active_post_types.includes( postType.slug ) }
						onChange={ () => {
							const activePostTypes = settings.active_post_types;
							if ( settings.active_post_types.includes( postType.slug ) ) {
								remove( activePostTypes, ( el ) => {
									return el === postType.slug;
								} );
							} else {
								activePostTypes.push( postType.slug );
							}
							updateSettings( {
								...settings,
								active_post_types: activePostTypes,
							} );
						} }
					/>
				</PanelRow>;
			}
			return [];
		} ) }
	</>;
};

export default compose( withSelect( ( select ) => {
	const { getPostTypes } = select( coreStore );
	const excludedPostTypes = [ 'attachment' ];
	const filteredPostTypes = getPostTypes( { per_page: -1 } )?.filter(
		( { viewable, slug } ) =>
			viewable && ! excludedPostTypes.includes( slug )
	);
	return {
		postTypesList: filteredPostTypes,
	};
} ) )( ActivePostTypes );
